import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { QuickOrderContainer } from './ProductSearch.styled';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import DeleteDark from 'src/assets/images/DeleteDarkIcon.svg';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import Button from 'src/common/components/button/Button';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import SearchGrayInactive from 'src/assets/images/SearchGrayInactive.svg';
import StepperAddBlue from 'src/assets/images/StepperAddBlue.svg';
import SearchDropdown from 'src/common/refactoredComponents/searchDropdown/SearchDropdown.jsx';
import {
    RowContainer,
    QtyAndDeleteContainer,
    SetNameAndDetailsContainer,
    SetCountAndDeleteContainer,
    ButtonsContainer,
    AutocompleteStyles,
    AutoCompleteInputFieldStyle,
    AutoCompleteTemplateContainer,
    AutoCompleteDescription,
    AutoCompleteTemplateHeader,
    QuickOrderHeaderContainer,
    AutoCompleteContainer,
    TextArea,
    TextAreaContainer,
    PopupContainer,
    GridHeaderContainer,
    LoadingTextStyles,
    SpinningLoaderContainer,
    OuterDiv,
    StyledDiv,
    DeleteContainer,
    Div,
    AddCartIcon,
    AddedCartButton,
} from './ProductSearch.styled';
import Popup from 'src/common/components/popup/Popup';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { EQUITYORDERTYPE } from 'src/pages/equity/components/common/constants';
import {
    searchProducts,
    searchProductsBulk,
    clearProducts,
    clearValidatedProducts,
    setProductSearchStatus,
} from 'src/pages/scheduleSurgery/redux/actions';
import { clearValidatedProducts as clearEquityValidatedProducts } from 'src/pages/equity/redux/actions';
import ExclusionItemsNotAllowed from 'src/pages/scheduleSurgery/components/surgery/notifications/ExclusionItemsNotAllowed';
import ItemNotAvailable from 'src/pages/scheduleSurgery/components/surgery/notifications/ItemNotAvailable';
import NoInventoryShippingNonTissueSet from 'src/pages/scheduleSurgery/components/surgery/notifications/NoInventoryShippingNonTissueSet';
import {
    dynamicPluralization,
    isIpad,
    isLandscape,
    isMobileView,
    updateNavBarPosition,
    cumThresLimitErrProdsCalc,
    cumThresLimitErrProdsCalcSurgery,
    debounce,
    logErrorToConsole,
} from 'src/utils/util';
import { PRODUCTVALIDATIONPOPUPMESSAGES } from 'src/constants/productConstants';
import axios from 'src/api/Api';
// import AccountOrSurgeonError from '../../surgery/notifications/AccountOrSurgeonError';
import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';
import ThresholdAndCumulativeLimitError from 'src/pages/scheduleSurgery/components/surgery/notifications/ThresholdAndCumulativeLimitError';
import { useLocation } from 'react-router-dom';
import { templateFlag } from 'src/pages/more/pages/templates/redux/action/index.js';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const specialCharactersRegex = /[ a-zA-Z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

// Quick orders Component
const ProductSearch = ({
    setProductsToBeAddedToCart: setProducts,
    productsToBeAddedToCart: products,
    setSelectedAddProductMethod,
    showBulkAdd,
    setShowBulkAdd,
    innerHeight,
    productSearch,
    addProductToTemplate,
    isFromSurgeryTemplate,
    clearError,
    AccountOrSurgeonError,
    productValidation,
    mobile,
    isFromEquity,
    isFromEquityTemplate,
    isFromConsignmentADD,
    isProductAddMethod,
    searchBoxWidth,
    pricing,
    isFromSurgery,
    setAdded = () => {},
    setProductToBeAddedEquityTemplate = () => {},
    setAddProductMethodFromSearch = () => {},
    setFromSearch=()=>{},
    isTemplate,
    id='',
    isSurgery,
    products: cartProducts, 
    cartData = [],
}) => {
    const { t } = useTranslation();
    const location = useLocation();
    useEffectWithErrorLogging(() => {
        if (isFromEquityTemplate || isFromSurgeryTemplate) {
            dispatch(templateFlag(true));
        }
    }, []);

    const productWithIsPlaceHolderSet = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsPlaceHolderSet
    );

    const {
        productsListBulk,
        loading,
        isBulkUpload,
        validatedProducts,
        // validatedProductsZLC,
        productValidationLoading,
        // validatedProductsKB,
        isShortTermConsignment,
        productSearchStatus,
        isExcludedExtraItem,
    } = useSelector(
        (state) => ({
            productsListBulk: state.productsSearchReducer.isBulkUpload
                ? state.productsSearchReducer.products
                : [],  
            loading: state.productsSearchReducer.loading,
            isBulkUpload: state.productsSearchReducer.isBulkUpload,
            productSearchStatus:
                state.productsSearchReducer.productSearchStatus,
            validatedProducts:
                location.pathname == '/consignmentAdd'
                    ? state.consignmentAddValidateProductsReducer
                          .validatedProducts
                    : isFromEquityTemplate
                    ? state.equityValidateProductsReducer?.validatedProducts
                    : state.validateProductsReducer.validatedProducts,
            productValidationLoading: state.validateProductsReducer.loading,
            loadingStatusArray:
                state.validateProductsReducer.loadingStatusArray || [],
            // validatedProductsKB: state.consignmentAddValidateProductsReducer.validatedProducts,
            isShortTermConsignment:
                state.consignmentAddReducer.consignmentAddDetails
                    .isShortTermConsignment,
            isExcluded: state.equityValidateProductsReducer?.validatedProducts[0]
                ?.isExcluded || false,
            isExcludedExtraItem: state.validateProductsReducer?.validatedProducts[0]
                      ?.isExcludedExtraItem ||
                  state.consignmentAddValidateProductsReducer
                      ?.validatedProducts[0]?.isExcludedExtraItem ||
                  false,
        }),
        shallowEqual
    );
    const accountError = useSelector((state) =>
        location.pathname === '/consignmentAdd'
            ? state.consignmentAddValidateProductsReducer.accountError
            : state.validateProductsReducer.accountError
    );
    const surgeonError = useSelector((state) =>
        location.pathname === '/consignmentAdd'
            ? state.consignmentAddValidateProductsReducer.surgeonError
            : state.validateProductsReducer.surgeonError
    );

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const dispatch = useDispatch();
    const winWidth = window.innerWidth;
    const ipadAir = winWidth === sizes.ipadAir;
    const ipadMini = winWidth === sizes.smalDevice;
    const ipadPro = winWidth === sizes.mediumDevice;
    const desktop = winWidth === sizes.largeDevice;
    const [bulkValues, setBulkValues] = useState('');
    const [open, setOpen] = useState(false);
    const [setDetails, showSetDetails] = useState(false);
    const [selectedItem, setSelectedItem] = useState('');
    const [itemDetails, showItemDetails] = useState(false);
    const [productStack, setProductStack] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState('');
    const [setOrItemNumbers, setSetOrItemNumbers] = useState([]);
    const [validationPopup, setValidationPopup] = useState({
        showPopup: false,
        productsNotAddedToCart: [],
        productsAddedToCart: 0,
    });
    const width = '100%';
    const AutocompleteStylesProductSearch = {
        width: width,
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        borderRadius: '25px',
    };
    const [showItemNotAvailablePopup, setShowItemNotAvailablePopup] =
        useState(false);
    const [showSetNotAvailablePopup, setShowSetNotAvailablePopup] =
        useState(false);
    const [showReservationErrorPopup, setShowReservationErrorPopup] =
        useState(false);
    const [productToBeAdded, setProductToBeAdded] = useState([]);
    const [accountErrorPopup, setAccountErrorPopup] = useState(false);
    const [surgeonErrorPopup, setSurgeonErrorPopup] = useState(false);
    const [showNonInventoryShippingPopup, setShowNonInventoryShippingPopup] =
        useState(false);
    const [showB33Popup, setShowB33Popup] = useState(false);
    const [showSpecialHandlingPopup, setShowSpecialHandlingPopup] =
        useState(false);
    const [
        thresholdAndCumulativeLimitError,
        setThresholdAndCumulativeLimitError,
    ] = useState({ error: false, errorText: '', productNotAdded: [] });
    const [popupNotificationsStack, setPopupNotificationsStack] = useState([]);
    const [axiosSource, setAxiosSource] = useState(axios.CancelToken.source());
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [editableHeight, setEditableHeight] = useState('');
    const autoCompleteRef = useRef(null);

    let timoutId;
    window.onresize = () => {
        setInnerWidth(window.innerWidth);
    }; 

    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
        window.addEventListener('orientationchange', updateLandscape, false);
        setIpad(isIpad());
        if (isIpad()) {
            updateNavBarPosition('unset');
        }
        return () => {
            window.removeEventListener(
                'orientationchange',
                updateLandscape,
                false
            );
            updateNavBarPosition('fixed');
        };
    }, []);

    const updateLandscape = () => {
        setEditableHeight('');
        document.activeElement.blur();
        setLandscape(!isLandscape());
        timoutId = setTimeout(() => {
            try {
                handleDynamicBulkAdd();
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 100);
    };
    const getProductsListAfterValidation = (
        productsList,
        validatedProducts
    ) => {
        const products = [...productsList];
        if (validatedProducts?.length > 0) {
            for (let i in products) {
                if (
                    products[i].cfn == validatedProducts[0].productCFN &&
                    products[i].salesOrg === productToBeAdded.salesOrg
                ) {
                    products[i].productAdded =
                        validatedProducts[0].productAdded;
                    break; //Stop this loop, we found it!
                }
            }
        }

        return products;
    };
    const [ipad, setIpad] = useState(isIpad());
    const [landscape, setLandscape] = useState(isLandscape());
    const { productsList } = useSelector(
        (state) => ({
            productsList: [
                ...getProductsListAfterValidation(
                    state.productsSearchReducer.products,
                    state.validateProductsReducer.validatedProducts
                ),
            ],
        }),
        shallowEqual
    );
    const handleDynamicBulkAdd = () => {
        if (ipad && landscape) {
            setEditableHeight('230px');
        } else {
            setEditableHeight('');
        }
        clearTimeout(timoutId);
        timoutId = undefined;
    };
    const handleSetItemClick = (item, isBack) => {
        const {
            isSet,
            // , cumulativeLimitPHValue, productCFN, cumulativeLimit, thresholdLimit
        } = item;

        if (isSet) {
            showSetDetails(true);
            setSelectedItem(item);
            showItemDetails(false);
            // setPreviousItem(item);
        } else {
            showSetDetails(false);
            showItemDetails(true);
            setSelectedItem(item);
        }
        handleProductStack(item, isBack === true ? false : true);
    };
    const handleProductStack = (item, isAdd) => {
        if (isAdd) {
            setProductStack([...productStack, item]);
        } else {
            let list = productStack.slice(0, -1);
            setProductStack(list);
        }
    };
    const cancelSearchRequest = () => {
        axiosSource?.cancel('Request cancelled');
        setAxiosSource(axios.CancelToken.source());
    };

    useEffectWithErrorLogging(() => {
        if (isBulkUpload && !loading) {
            const clonedExistingProducts = [...products];
            productsListBulk.forEach((product) => {
                const productIndex = clonedExistingProducts.findIndex(
                    (exProduct) => exProduct.cfn === product.cfn
                );

                if (productIndex !== -1) {
                    clonedExistingProducts[productIndex].quantity =
                        parseInt(
                            clonedExistingProducts[productIndex].quantity
                                ? clonedExistingProducts[productIndex].quantity
                                : 0
                        ) + parseInt(product.quantity);
                    if (clonedExistingProducts[productIndex].quantity > 50) {
                        clonedExistingProducts[productIndex].quantity = 50;
                        clonedExistingProducts[productIndex].error = true;
                    } else {
                        clonedExistingProducts[productIndex].error = false;
                    }
                } else {
                    clonedExistingProducts.push(product);
                }
            });
            setProducts(
                clonedExistingProducts.sort((a, b) => a.quantity - b.quantity)
            );
            setBulkValues('');
        }
    }, [productsListBulk, loading, isBulkUpload, setProducts, setBulkValues]);

    //popup notifications handler
    useNonInitialRenderHook(() => {
        const { thresholdLimit, cumulativeLimit } =
            popupNotificationsStack[0] || {};
        if (popupNotificationsStack.length != 0) {
            if (popupNotificationsStack[0].accountError) {
                setAccountErrorPopup(true);
            } else if (popupNotificationsStack[0].surgeonError) {
                setSurgeonErrorPopup(true);
            } else if (popupNotificationsStack[0].isB33Item) {
                setShowB33Popup(true);
            } else if (popupNotificationsStack[0].itemReservationError) {
                setShowReservationErrorPopup(true);
            } else if (popupNotificationsStack[0].nonInventoryShipping) {
                setShowNonInventoryShippingPopup(true);
            } else if (popupNotificationsStack[0].itemExcluded) {
                setShowItemNotAvailablePopup(true);
            } else if (popupNotificationsStack[0].itemExcludedExtra) {
                setShowItemNotAvailablePopup(true);
                setValidationPopup({
                    showPopup: true,
                    productsNotAddedToCart:
                        popupNotificationsStack[0].productsNotAddedToCart,
                });
            } else if (popupNotificationsStack[0].setExcluded) {
                setShowSetNotAvailablePopup(true);
            } else if (popupNotificationsStack[0].setExcludedExtra) {
                setShowItemNotAvailablePopup(true);
                setValidationPopup({
                    showPopup: true,
                    productsNotAddedToCart:
                        popupNotificationsStack[0].productsNotAddedToCart,
                });
            } else if (popupNotificationsStack[0].thresholdLimitError) {
                setThresholdAndCumulativeLimitError({
                    error: true,
                    errorText:
                         
                            popupNotificationsStack[0].salesOrg === 'S030'
                                ? t('common.thresholdLimitError').replace(
                                    '${thresholdLimit}',
                                    popupNotificationsStack?.[0]?.thresholdLimit
                                )
                                : t(
                                    'common.thresholdLimitErrorNonTissue'
                                ).replace(
                                    '${thresholdLimit}',
                                    popupNotificationsStack?.[0]?.thresholdLimit
                                ),
                });
            } else if (popupNotificationsStack[0].cumulativeLimitError) {
                setThresholdAndCumulativeLimitError({
                    error: true,
                    errorText:
                        popupNotificationsStack[0].salesOrg === 'S030'
                           ? t('common.cumulativeLimitError').replace(
                                    '${cumulativeLimit}',
                                    popupNotificationsStack?.[0]?.cumulativeLimit
                                )
                                : t(
                                    'common.cumulativeLimitErrorNonTissue'
                                ).replace(
                                    '${cumulativeLimit}',
                                    popupNotificationsStack?.[0]?.cumulativeLimit
                                ),
                });
            } else if (
                popupNotificationsStack[0].productFamily &&
                !(popupNotificationsStack[0].itemExcludedExtra||popupNotificationsStack[0].itemExcluded)
            ) {
                setShowSpecialHandlingPopup(true);
            }
        } else if (isFromSurgeryTemplate) {
            setShowItemNotAvailablePopup(false);
            setShowSetNotAvailablePopup(false);
        }
    }, [popupNotificationsStack]);
    // handler for validating products

    useEffectWithErrorLogging(() => {
        if (
            validatedProducts.length > 0 ||
            accountError?.length > 0 ||
            surgeonError?.length > 0
        ) {
            const popupsStack = [];
            const productReservationError =
                countryISOCode === 'JP' &&
                validatedProducts.filter(
                    (product) => product.reservationSetErrorMessage
                );
            const productsNotAddedToCartExcludedExtraItem =
                validatedProducts.filter(
                    (product) => product.isExcludedExtraItem && !product.isSet
                );
            const productsNotAddedToCartExcludedExtraSet =
                validatedProducts.filter(
                    (product) => product.isExcludedExtraItem && product.isSet
                );
            const productsNotAddedToCartExcludedItem = validatedProducts.filter(
                (product) => product.isExcluded && !product.isSet
            );
            const productsNotAddedToCartNonInventoryShipping =
                validatedProducts.filter(
                    (product) => product.nonInventoryShipping
                );
            const productsNotAddedToCartB33Item = validatedProducts.filter(
                (product) => product.isB33Item
            );
            const productsNotAddedToCartProductFamily =
                validatedProducts.filter(
                    (product) => product?.productFamily?.length > 0
                );
            //For items which are having only threshold limit
            const productsNotAddedToCartThresholdLimitError =
                countryISOCode === 'JP'
                    ? validatedProducts.filter(
                        (product) =>
                            product.thresholdLimitError &&
                            !product?.cumulativeLimitPHValue
                        //    && product.isSet
                    )
                    : validatedProducts.filter(
                        (product) =>
                            product.thresholdLimitError &&
                            !product?.cumulativeLimitPHValue
                    );
            //For items which are having threshold limit or cumulative limit
            const cumulativeOrThresholdErrorProducts =
                cumThresLimitErrProdsCalcSurgery(validatedProducts);
            if (
                productsNotAddedToCartExcludedItem.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({ itemExcluded: true });
            }
            if (productReservationError.length > 0) {
                popupsStack.push({ itemReservationError: true });
            }
            if (
                productsNotAddedToCartExcludedExtraItem.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({
                    itemExcludedExtra: true,
                    showPopup: true,
                    productsNotAddedToCart:
                        productsNotAddedToCartExcludedExtraItem,
                });
            }
            if (
                productsNotAddedToCartExcludedExtraSet.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({
                    setExcludedExtra: true,
                    showPopup: true,
                    productsNotAddedToCart:
                        productsNotAddedToCartExcludedExtraSet,
                });
            }
            if (
                productsNotAddedToCartNonInventoryShipping.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({ nonInventoryShipping: true });
            }
            if (
                !(productsNotAddedToCartExcludedItem.length > 0 ||
                    productsNotAddedToCartExcludedExtraItem.length > 0) &&
                productsNotAddedToCartProductFamily.length > 0
            ) {
                popupsStack.push({ productFamily: true });
            }
            if (productsNotAddedToCartThresholdLimitError.length > 0) {
                popupsStack.push(...productsNotAddedToCartThresholdLimitError);
            }
            if (Object.keys(cumulativeOrThresholdErrorProducts).length > 0) {
                let keyList = Object.keys(cumulativeOrThresholdErrorProducts);
                keyList.map((pr, ind) => {
                    popupsStack.push({
                        thresholdLimitError:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .thresholdLimitError,
                        thresholdLimit:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .thresholdLimit,
                        cumulativeLimitError:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .cumulativeLimitError,
                        productsNotAddedToCart:
                            cumulativeOrThresholdErrorProducts[pr],
                        salesOrg:
                            cumulativeOrThresholdErrorProducts[pr][0].salesOrg,
                        cumulativeLimit:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .cumulativeLimit,
                    });
                });
                // popupsStack.push(cumulativeOrThresholdErrorProducts);
            }
            if (productsNotAddedToCartB33Item.length > 0) {
                popupsStack.push({ isB33Item: true });
            }
            if (accountError?.length > 0 || surgeonError?.length > 0) {
                if (accountError.length > 0) {
                    popupsStack.push({ accountError: true });
                }
                if (surgeonError.length > 0) {
                    popupsStack.push({ surgeonError: true });
                }
            }

            setPopupNotificationsStack(popupsStack);
        } else if (isFromSurgeryTemplate) { 
            setPopupNotificationsStack([]);
        }
    }, [validatedProducts, accountError, surgeonError]);
    const emptySearch = (event) => {
        if (event.key === 'Enter' && selectedProduct.length === 0) {
            setOpen(true);
            if (isFromEquity) {
                dispatch(
                    searchProducts({
                        searchParam: 'all',
                        orderType: EQUITYORDERTYPE, //ZLC~ZOR
                        pageNum: 0,
                        pageLimit: 50,
                        searchTerm: '',
                        cancelSearchToken: axiosSource.token,
                    })
                );
            } else if (isFromConsignmentADD) {
                dispatch(
                    searchProducts({
                        searchParam: 'all',
                        orderType: 'KB',
                        pageNum: 0,
                        pageLimit: 50,
                        searchTerm: '',
                        cancelSearchToken: axiosSource.token,
                        isBKPProductsDisplay: isShortTermConsignment
                            ? true
                            : false,
                    })
                );
            } else {
                dispatch(
                    searchProducts({
                        searchParam: 'all',
                        orderType: isFromConsignmentADD ? 'KB' : 'ZLC',
                        pageNum: 0,
                        pageLimit: 50,
                        searchTerm: '',
                        cancelSearchToken: axiosSource.token,
                    })
                );
            }
        }

        if (event.key === 'Enter') {
            document.activeElement.blur();
            event.preventDefault();
        }
    };

    const onClose = () => {
        setOpen(false);
        cancelSearchRequest();
        setSelectedProduct('');
    }

    const appendUniqueTemplateProduct = (previousProducts, nextProduct) => {
        const normalizedProducts = Array.isArray(previousProducts)
            ? previousProducts
            : previousProducts
              ? [previousProducts]
              : [];
        const nextProductKey = nextProduct?.productCFN || nextProduct?.cfn;

        const alreadyQueued = normalizedProducts.some((product) => {
            const productKey = product?.productCFN || product?.cfn;
            return (
                productKey === nextProductKey &&
                product?.salesOrg === nextProduct?.salesOrg
            );
        });

        return alreadyQueued
            ? normalizedProducts
            : [...normalizedProducts, { ...nextProduct }];
    };

    // handler for validating products
    useEffectWithErrorLogging(() => {
        if (
            validatedProducts.length > 0 ||
            accountError?.length > 0 ||
            surgeonError?.length > 0
        ) {
            const popupsStack = [];
            const productReservationError =
                countryISOCode === 'JP' &&
                validatedProducts.filter(
                    (product) => product.reservationSetErrorMessage
                );
            const productsNotAddedToCartExcludedExtraItem =
                validatedProducts.filter(
                    (product) => product.isExcludedExtraItem && !product.isSet
                );
            const productsNotAddedToCartExcludedExtraSet =
                validatedProducts.filter(
                    (product) => product.isExcludedExtraItem && product.isSet
                );
            const productsNotAddedToCartExcludedItem = validatedProducts.filter(
                (product) => product.isExcluded && !product.isSet
            );
            const productsNotAddedToCartExcludedSet = validatedProducts.filter(
                (product) => product.isExcluded && product.isSet
            );
            const productsNotAddedToCartNonInventoryShipping =
                validatedProducts.filter(
                    (product) => product.nonInventoryShipping
                );
            const productsNotAddedToCartB33Item = validatedProducts.filter(
                (product) => product.isB33Item
            );
            const productsNotAddedToCartProductFamily =
                validatedProducts.filter(
                    (product) => product?.productFamily?.length > 0
                );
            //For items which are having only threshold limit
            const productsNotAddedToCartThresholdLimitError =
                countryISOCode === 'JP'
                    ? validatedProducts.filter(
                          (product) =>
                              product.thresholdLimitError &&
                              !product?.cumulativeLimitPHValue
                          //    && product.isSet
                      )
                    : validatedProducts.filter(
                          (product) =>
                              product.thresholdLimitError &&
                              !product?.cumulativeLimitPHValue
                      );
            //For items which are having threshold limit or cumulative limit
            const cumulativeOrThresholdErrorProducts =
                cumThresLimitErrProdsCalcSurgery(validatedProducts);
            if (
                productsNotAddedToCartExcludedItem.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({ itemExcluded: true });
            }
            if(productsNotAddedToCartNonInventoryShipping.length > 0){
                popupsStack.push({ nonInventoryShipping: true });
            }
            if (
                productsNotAddedToCartExcludedSet.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({ setExcluded: true });
            }
            if (productReservationError.length > 0) {
                popupsStack.push({ itemReservationError: true });
            }
            if (
                productsNotAddedToCartExcludedExtraItem.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({
                    itemExcludedExtra: true,
                    showPopup: true,
                    productsNotAddedToCart:
                        productsNotAddedToCartExcludedExtraItem,
                });
            }
            if (
                productsNotAddedToCartExcludedExtraSet.length > 0 &&
                !productsNotAddedToCartB33Item.length > 0
            ) {
                popupsStack.push({
                    setExcludedExtra: true,
                    showPopup: true,
                    productsNotAddedToCart:
                        productsNotAddedToCartExcludedExtraSet,
                });
            }

            if ( !(productsNotAddedToCartExcludedItem.length > 0 ||
                    productsNotAddedToCartExcludedExtraItem.length > 0)&& productsNotAddedToCartProductFamily.length > 0) {
                popupsStack.push({ productFamily: true });
            }
            if (productsNotAddedToCartThresholdLimitError.length > 0) {
                popupsStack.push(...productsNotAddedToCartThresholdLimitError);
            }
            if (Object.keys(cumulativeOrThresholdErrorProducts).length > 0) {
                let keyList = Object.keys(cumulativeOrThresholdErrorProducts);
                keyList.map((pr, ind) => {
                    popupsStack.push({
                        thresholdLimitError:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .thresholdLimitError,
                        thresholdLimit:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .thresholdLimit,
                        cumulativeLimitError:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .cumulativeLimitError,
                        productsNotAddedToCart:
                            cumulativeOrThresholdErrorProducts[pr],
                        salesOrg:
                            cumulativeOrThresholdErrorProducts[pr][0].salesOrg,
                        cumulativeLimit:
                            cumulativeOrThresholdErrorProducts[pr][0]
                                .cumulativeLimit,
                    });
                });
                // popupsStack.push(cumulativeOrThresholdErrorProducts);
            }
            if (productsNotAddedToCartB33Item.length > 0) {
                popupsStack.push({ isB33Item: true });
            }
            if (accountError?.length > 0 || surgeonError?.length > 0) {
                if (accountError.length > 0) {
                    popupsStack.push({ accountError: true });
                }
                if (surgeonError.length > 0) {
                    popupsStack.push({ surgeonError: true });
                }
            }

            setPopupNotificationsStack(popupsStack);
        }
    }, [validatedProducts]);

    // clearing products list on unmounting of quick order commponent
    useEffectWithErrorLogging(() => {
        const handleBeforeUnload = () => {
            dispatch(clearProducts());
            // dispatch(clearValidatedProducts());
            setProducts([]);
            setValidationPopup({
                showPopup: false,
                productsNotAddedToCart: [],
            });
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    // this methods updates the products list with newly selected products
    const updateSelectedProduct = (value) => {
        setSelectedProduct(value ? value.cfn : '');
        if (value) {
            const updatedProductList = [...products];
            if (
                !updatedProductList.find((product) => value.cfn === product.cfn)
            ) {
                updatedProductList.push({ ...value, quantity: 1 });
                setProducts(updatedProductList);
            }
            // document.activeElement.blur();
        }
    };

    const debouncedProductList = useRef(
        debounce((option) => {
            dispatch(searchProducts(option));
        }, 500)
    ).current;

    // this method triggers when input changes in the autocomplete search box
    const autoCompleteInputChange = (e, value, reason) => {
        dispatch(setProductSearchStatus(true));
        if (reason !== 'reset') setSelectedProduct(value);

        if (value.trim().length == 0 && reason !== 'reset') {
            setOpen(false);
            dispatch(clearProducts());
        }

        if (value?.trim().length >= 3 && reason !== 'reset') {
            isIpad() && updateNavBarPosition('unset');
            setOpen(true);
            if (isFromEquity || isFromEquityTemplate) {
                debouncedProductList({
                    orderType: 'ZOR',
                    pageLimit: 50,
                    searchParam: 'all',
                    searchTerm: value,
                    uhOrder: false,
                });
            } else if (isFromConsignmentADD) {
                debouncedProductList({
                    orderType: 'KB',
                    searchParam: 'all',
                    searchTerm: value,
                    uhOrder: false,
                    isBKPProductsDisplay: isShortTermConsignment ? true : false,
                });
            } else {
                debouncedProductList({
                    searchParam: 'all',
                    searchTerm: value,
                    orderType: isFromConsignmentADD ? 'KB' : 'ZLC',
                    cancelSearchToken: axiosSource.token,
                });
            }
        }
    };
    // this method extracts the text from clipboard and sets the text to text area
    const copyToClipBoard = () => {
        navigator.clipboard
            .readText()
            .then((result) => {
                const finalResult = bulkValues.length
                    ? `${bulkValues}\n ${result}`
                    : result;
                setBulkValues(finalResult);
            })
            .catch((error) => {});
    };
    // this method adds the products from bulk add to the products list
    const addToList = () => {
        let setOrItemNumbers = [];
        let setOrItemNumbersFinal = [];
        if (!!bulkValues && bulkValues.includes('\n')) {
            setOrItemNumbers = bulkValues
                .split('\n')
                .map((element) => element.replace(/[\r\n]+/gm, '').trim())
                .filter((item) => item.length > 0);
            setOrItemNumbers.forEach((item) => {
                setOrItemNumbersFinal = [
                    ...setOrItemNumbersFinal,
                    ...item
                        .split(',')
                        .map((ele) => ele.trim())
                        .filter((item) => item.length > 0),
                ];
            });
            setSetOrItemNumbers(setOrItemNumbersFinal);
        } else if (bulkValues.includes(',')) {
            setOrItemNumbersFinal = bulkValues
                .split(',')
                .map((element) => element.trim())
                .filter((item) => item.length > 0);
            setSetOrItemNumbers(setOrItemNumbersFinal);
        } else if (bulkValues.length) {
            setOrItemNumbersFinal = bulkValues
                .split(',')
                .map((item) => item.trim());
            setSetOrItemNumbers(setOrItemNumbersFinal);
        } else {
            return;
        }
        dispatch(searchProductsBulk(setOrItemNumbersFinal));
        setShowBulkAdd(false);
    };
    // this method delete individual product from the list
    const deleteSetOrItem = (cfn) => {
        const clonedProducts = [...products];
        const filteredProducts = clonedProducts.filter(
            (product) => product.cfn !== cfn || !cfn
        );
        setProducts(filteredProducts);
    };

    const handleOnOpen = () => {
        if (selectedProduct.trim().length > 2) {
            isIpad() && updateNavBarPosition('unset');
            setOpen(true);
        }
    };

    let body = document.getElementById('body');

    useEffectWithErrorLogging(() => {
        if (showBulkAdd) {
            body.style.overflow = 'hidden';
            var x = window.scrollX;
            var y = window.scrollY;
            window.onscroll = function () {
                window.scrollTo(x, y);
            };
        } else {
            body.style.overflow = '';
            window.onscroll = function () {};
        }
    }, [showBulkAdd]);

    useEffectWithErrorLogging(() => {
        setTimeout(() => {
            try {
                innerWidth === sizes.smalDevice || innerWidth === sizes.mediumDevice
                    ? (body.style.overflow = 'hidden')
                    : (body.style.overflow = '');
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 1000);

        return () => (body.style.overflow = '');
    }, [innerWidth]);

    window.onorientationchange = () => {
        setOpen(false);
        setTimeout(() => {
            try {
                if (selectedProduct.length >= 3) {
                    setOpen(true);
                }
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 200);
    };

    const resetPosition = () => {
        setEditableHeight('');
        setTimeout(() => {
            try {
                if (isMobileView() || isIpad()) {
                    document.getElementById('popUpContent').style.position = '';
                    document.getElementById('popUpContent').style.top = '';
                }
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 0);
    };

    // Find nearest scrollable container
    const getScrollParent = (node) => {
        if (!node) return null;
        let parent = node.parentElement;
        while (parent) {
            const style = window.getComputedStyle(parent);
            const overflowY = style.overflowY;
            if ((overflowY === 'auto' || overflowY === 'scroll') && parent.scrollHeight > parent.clientHeight) {
                return parent;
            }
            parent = parent.parentElement;
        }
        return document.scrollingElement || document.documentElement;
    };

    // Scroll element into view with a top offset (e.g., header height)
    const scrollIntoViewWithOffset = (el, offset) => {
        const container = getScrollParent(el);
        const elRect = el.getBoundingClientRect();
        if (container === document.scrollingElement || container === document.documentElement || container === document.body) {
            const top = window.pageYOffset + elRect.top - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        } else {
            const containerRect = container.getBoundingClientRect();
            const top = container.scrollTop + (elRect.top - containerRect.top) - offset;
            container.scrollTo({ top, behavior: 'smooth' });
        }
    };

    // Callback to run when AutoComplete gets focused
    const handleAutoCompleteFocus = () => {
        const el = autoCompleteRef.current;
        if (!el) return;
        // Try to read header height if there's an element with id="header"; fallback to 100px
        const headerEl = document.querySelector('header');
        const offset = headerEl && headerEl.offsetHeight ? headerEl.offsetHeight : 0;
        scrollIntoViewWithOffset(el, offset);
    };

    const isAnyPopupOpen =
        showNonInventoryShippingPopup ||
        showItemNotAvailablePopup ||
        showSetNotAvailablePopup ||
        showReservationErrorPopup ||
        accountErrorPopup ||
        surgeonErrorPopup ||
        showSpecialHandlingPopup ||
        (thresholdAndCumulativeLimitError &&
            thresholdAndCumulativeLimitError.error);

    return (
        <>
            {/* Only non-tissue sets can be added */}
            {showNonInventoryShippingPopup && createPortal(
                <NoInventoryShippingNonTissueSet
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setShowNonInventoryShippingPopup(false);
                            dispatch(clearValidatedProducts());
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />,
                document.body
            )}
            {/* {showB33Popup && (
                <UnidRodCannotModifyNotification
                    onClose={() => {
                        const popups = [...popupNotificationsStack];
                        popups.splice(0, 1);
                        setPopupNotificationsStack(popups);
                        setShowB33Popup(false);
                    }}
                />
            )} */}
            {/* Item not available popup */}
            {showItemNotAvailablePopup &&
                !isFromSurgeryTemplate && createPortal(
                    <ItemNotAvailable
                        headings={
                            PRODUCTVALIDATIONPOPUPMESSAGES()[
                                isFromEquityTemplate ? 'itemNotAvailable' : 'itemNotAllowedAsExtra'
                            ]
                        }
                        onClose={() => {
                            try {
                                const popups = [...popupNotificationsStack];
                                popups.splice(0, 1);
                                setPopupNotificationsStack(popups);
                                setShowItemNotAvailablePopup(false);
                                dispatch(clearValidatedProducts());
                                dispatch(clearEquityValidatedProducts());
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    />,
                    document.body
                )}

            {/* Set not available popup */}
            {showSetNotAvailablePopup &&
                !isFromSurgeryTemplate && createPortal(
                    <ItemNotAvailable
                        headings={
                            PRODUCTVALIDATIONPOPUPMESSAGES()[
                                'setNotAllowedAsExtra'
                            ]
                        }
                        onClose={() => {
                            try {
                                const popups = [...popupNotificationsStack];
                                popups.splice(0, 1);
                                setPopupNotificationsStack(popups);
                                setShowSetNotAvailablePopup(false);
                                // setOpen(true);
                                dispatch(clearValidatedProducts());
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    />,
                    document.body
                )}

            {showReservationErrorPopup && createPortal(
                <ItemNotAvailable
                    headings={{
                        title: t('scheduleSurgery.details.setNotAllowed'),
                        heading1: validatedProducts?.filter(
                            (d) => d.reservationSetErrorMessage
                        )[0]?.reservationSetErrorMessage,
                        button: t(
                            'scheduleSurgery.surgery.notifications.ExclusionItemsNotAllowed.continueButton'
                        ),
                    }}
                    excludedItems={true}
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setShowReservationErrorPopup(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />,
                document.body
            )}
            {accountErrorPopup && createPortal(
                <AccountOrSurgeonError
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setAccountErrorPopup(false);
                            if (popups.length === 0) {
                                dispatch(clearError());
                            }
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    title={t('productValidationMessages.productRestricted')}
                    message={
                        accountError &&
                        accountError.length > 0 &&
                        accountError[0]?.statusDescription
                    }
                    productsNotAddedToCart={
                        accountError &&
                        accountError.length > 0 &&
                        accountError[0]?.products
                    }
                />,
                document.body
            )}
            {surgeonErrorPopup && createPortal(
                <AccountOrSurgeonError
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setSurgeonErrorPopup(false);
                            if (popups.length === 0) {
                                dispatch(clearError());
                            }
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    title={t('productValidationMessages.productRestricted')}
                    message={
                        surgeonError &&
                        surgeonError?.length > 0 &&
                        surgeonError[0]?.statusDescription
                    }
                    productsNotAddedToCart={
                        surgeonError &&
                        surgeonError?.length > 0 &&
                        surgeonError[0]?.products
                    }
                />,
                document.body
            )}
            {showSpecialHandlingPopup&&!isTemplate  && createPortal(
                <ItemNotAvailable
                    headings={
                        PRODUCTVALIDATIONPOPUPMESSAGES()[
                            'specialHandlingRequired'
                        ]
                    }
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setShowSpecialHandlingPopup(false);
                            dispatch(clearValidatedProducts());
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    isProductFamily={true}
                />,
                document.body
            )}

            {thresholdAndCumulativeLimitError.error && (!isTemplate && isSurgery) && createPortal(
                <div style={{textWrap: 'auto'}}>
                <ThresholdAndCumulativeLimitError
                    title={thresholdAndCumulativeLimitError.errorText}
                   
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setThresholdAndCumulativeLimitError({
                                error: false,
                                errorText:'',
                            });
                            dispatch(clearValidatedProducts());
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
               
                />
                </div>,
                document.body
            )}
                <QuickOrderContainer
                    searchBoxWidth={searchBoxWidth || '100%'}
                    overFlowY={
                        !productSearch && !showBulkAdd ? false : 'hidden'
                    }
                    
                >
                    <QuickOrderHeaderContainer>
                        <AutoCompleteContainer searchBoxWidth={searchBoxWidth}>
                            <AutoComplete
                                inputRef={autoCompleteRef}
                                disableCloseOnSelect
                                onFocus={handleAutoCompleteFocus}
                                isSearchDropdown={true}
                                id={id + '-productSearch'}
                                forcePopupIcon={false}
                                disableClearable={false}
                                landscapeWidth={'60%'}
                                className="autocomplete"
                                isProductSearch={true}
                                value={selectedProduct}
                                inputValue={selectedProduct}
                                options={productsList}
                                onOpen={handleOnOpen}
                                open={open} 
                                closeOnAllowedReasons={['blur', 'outside-click', 'escape', 'empty-input']}
                                ignoreBlurWhenFocusInPopup
                                onClose={(event, reason) => {
                                    try {
                                        setFromSearch && setFromSearch(false);
                                        (isFromEquityTemplate || isFromSurgeryTemplate) &&
                                        setAddProductMethodFromSearch(false);
                                        if (isAnyPopupOpen) {
                                            return;
                                        }

                                        setOpen(false);
                                        cancelSearchRequest();
                                        autoCompleteInputChange(null, '', 'clear');
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                loading={loading}
                                searchIconHeight={'19px'}
                                searchIconWidth={'19px'}
                                style={
                                    productSearch
                                        ? AutocompleteStylesProductSearch
                                        : AutocompleteStyles
                                }
                                isFromPhysician={true}
                                getOptionDisabled={(option) =>
                                    productWithIsPlaceHolderSet?.some((product) => product.cfn === option.cfn)
                                }
                                itemTemplate={(option) => {
                                    return (
                                    <SearchDropdown
                                        data={option} 
                                        padding={'10px'} 
                                        productSearchDropdown={true} 
                                        cartProducts={cartProducts}
                                        isFromEquity={isFromEquity}
                                        cartData={cartData}
                                        isFromConsignmentADD={isFromConsignmentADD}
                                        isFromSurgeryTemplate={isFromSurgeryTemplate}
                                        isFromEquityTemplate={isFromEquityTemplate}
                                        onClose={() => {
                                            autoCompleteInputChange(null, '', 'clear');
                                            setFromSearch && setFromSearch(false);
                                            onClose();
                                        }}
                                    />
                                );}
                            }
                                onChange={(value) => {
                                    if (value !== '') {
                                        setOpen(true);
                                        const alreadyAdded = productWithIsPlaceHolderSet?.some(
                                            (product) => product.cfn === value.cfn
                                        );
                                        if (alreadyAdded) {
                                            setSelectedProduct('');
                                            return;
                                        }
                                        (isFromEquityTemplate || isFromSurgeryTemplate) &&
                                        setAddProductMethodFromSearch(true);
                                        if (value.materialType === 'ZKMT') { 
                                            isFromEquityTemplate
                                                ? productValidation(
                                                      [value],
                                                      'Bundle',
                                                      value
                                                  )
                                                : productValidation(
                                                      [value],
                                                      'bundle',
                                                      value,
                                                      true
                                                  );
                                            
                                                (isFromSurgeryTemplate ||
                                                    isFromEquityTemplate) &&
                                                    setProductToBeAddedEquityTemplate(
                                                        (prev) =>
                                                            appendUniqueTemplateProduct(
                                                                prev,
                                                                value
                                                            )
                                                    );
                                            (isFromEquityTemplate ||
                                                isFromSurgeryTemplate) &&
                                                setAdded(false);
                                        } else { 
                                            !isFromEquityTemplate &&
                                                setProductToBeAdded(value);

                                            isFromEquityTemplate
                                                ? productValidation(
                                                      [value],
                                                      '',
                                                      value
                                                  )
                                                : productValidation(
                                                      [value],
                                                      '',
                                                      '',
                                                      true
                                                  );

                                            (isFromSurgeryTemplate || isFromEquityTemplate) &&
                                                setProductToBeAddedEquityTemplate(
                                                    (prev) =>
                                                        appendUniqueTemplateProduct(
                                                            prev,
                                                            value
                                                        )
                                                );
                                            (isFromEquityTemplate ||
                                                isFromSurgeryTemplate) &&
                                                setAdded(false);
                                        }
                                    } 
                                }}
                                onInputChange={(e, value, reason) =>
                                    autoCompleteInputChange(e, value, reason)
                                }
                                placeholder={
                                    ipadPro || ipadAir || ipadMini
                                        ? t('common.searchAddProducts')
                                        : t('common.searchByProductNumber')
                                }
                                field="cfn"
                                filterField="cfn"
                                optionValue="cfn"
                                showSearchIcon
                                autoCompleteInputFieldStyle={
                                    AutoCompleteInputFieldStyle
                                }
                                loadingText={t('common.loadingText')}
                                noOptionsText={
                                    !loading &&
                                    productsList?.length === 0 &&
                                    !productSearchStatus
                                        ? t('common.noResultFoundText')
                                        : loading
                                        ? t('common.loadingText')
                                        : t('common.loadingText')
                                }
                                fontSizePlaceholder={
                                    ipadAir || ipadMini ? '12' : '14px'
                                }
                                paddingLeft={
                                    mobile
                                        ? '0px'
                                        : ipadAir || ipadPro || ipadMini
                                        ? ''
                                        : ''
                                }
                                mbPaddingLeft={mobile ? '' : '15px'}
                                fontSize={ipadAir || ipadMini ? '12px' : '14px'}
                                border={'1px solid #EBEDED'}
                                optionPadding={'14px 16px'}
                                // hoverBgColor={'none'}
                                showScrollBar={true}
                                // onKeyPress={handlekeyPress}
                                zIndex={'1500'}
                                isFromSurgeryTemplate={isFromSurgeryTemplate}
                                isProductAddMethod={isProductAddMethod}
                                surgeryShipTo={true}
                            />
                        </AutoCompleteContainer>
                    </QuickOrderHeaderContainer>
                </QuickOrderContainer>
            {/* )} */}
        </>
    );
};

export default ProductSearch;
